import ISubmissionLinkVerifiedEmailView from 'types/ISubmissionLinkVerifiedEmailView'

export const SET_ENTERPRISE_INITIATIVE_INFO = 'enterpriseInitiativeLoaderComponent.setEnterpriseInitiativeInfo'
export const SET_IS_LOADING_ENTERPRISE_INITIATIVE_INFO =
  'enterpriseInitiativeLoaderComponent.setIsLoadingEnterpriseInitiativeInfo'

export function setEnterpriseInitiativeInfo(payload: ISubmissionLinkVerifiedEmailView) {
  return {
    type: SET_ENTERPRISE_INITIATIVE_INFO,
    payload
  } as const
}

export function setIsLoadingEnterpriseInitiativeInfo(payload: boolean) {
  return {
    type: SET_IS_LOADING_ENTERPRISE_INITIATIVE_INFO,
    payload
  } as const
}

export type EnterpriseInitiativeLoaderAction = ReturnType<
  typeof setEnterpriseInitiativeInfo | typeof setIsLoadingEnterpriseInitiativeInfo
>
